import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appTabsWrapperContent]',
})
export class TabWrapperContentDirective {
  @Input('appTabsWrapperContent') id!: number;

  constructor(public template: TemplateRef<unknown>) {}
}
